var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{domProps:{"textContent":_vm._s(_vm.$t('context.scenarioPage.pages.scenarioChart.scenarioChartTitle'))}}),_c('BarChart',{attrs:{"chartId":19,"chartData":_vm.chartData,"overrideChartSelection":"","hideDescription":"","showLegendTip":false,"headingOverride":""}}),_c('p',[_c('span',{domProps:{"textContent":_vm._s(
        _vm.$t('context.scenarioPage.pages.scenarioChart.moreInfo.normalText')
      )}}),_c('router-link',{attrs:{"to":{ name: 'Data' }},domProps:{"textContent":_vm._s(
        _vm.$t('context.scenarioPage.pages.scenarioChart.moreInfo.linkText')
      )}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }